var _path, _path2, _g, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomepageHeroSubHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1439,
    height: 160,
    viewBox: "0 0 1439 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_52722)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_184_52722",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -275,
    y: -20,
    width: 2235,
    height: 428
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-274.002 408H1959.31V-19.7598H-274.002V408Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_184_52722)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_184_52722",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -271,
    y: 49,
    width: 2231,
    height: 353
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-270.514 401.025H1959.31V49.9817H-270.514V401.025Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_184_52722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3629 56.9573H51.6892V54.6325H49.3629V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.197 56.9573H107.524V54.6325H105.197V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.029 56.9573H163.355V54.6325H161.029V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.86 56.9573H219.186V54.6325H216.86V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.698 56.9573H275.024V54.6325H272.698V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.525 56.9573H330.852V54.6325H328.525V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.357 56.9573H386.683V54.6325H384.357V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.194 56.9573H442.521V54.6325H440.194V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.026 56.9573H498.352V54.6325H496.026V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.854 56.9573H554.18V54.6325H551.854V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.691 56.9573H610.018V54.6325H607.691V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.523 56.9573H665.849V54.6325H663.523V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.357 56.9573H721.683V54.6325H719.357V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.19 56.9573H777.516V54.6325H775.19V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.02 56.9573H833.346V54.6325H831.02V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.854 56.9573H889.181V54.6325H886.854V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.687 56.9573H945.013V54.6325H942.687V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.518 56.9573H1000.84V54.6325H998.518V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.35 56.957H1056.68V54.6322H1054.35V56.957Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.19 56.9573H1112.51V54.6325H1110.19V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.02 56.9573H1168.34V54.6325H1166.02V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.85 56.9573H1224.18V54.6325H1221.85V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.68 56.9573H1280.01V54.6325H1277.68V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.52 56.9573H1335.84V54.6325H1333.52V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.35 56.9573H1391.67V54.6325H1389.35V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3629 112.752H51.6892V110.427H49.3629V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.197 112.752H107.524V110.427H105.197V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.029 112.752H163.355V110.427H161.029V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.86 112.752H219.186V110.427H216.86V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.698 112.752H275.024V110.427H272.698V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.525 112.752H330.852V110.427H328.525V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.357 112.752H386.683V110.427H384.357V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.194 112.752H442.521V110.427H440.194V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.026 112.752H498.352V110.427H496.026V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.854 112.752H554.18V110.427H551.854V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.691 112.752H610.018V110.427H607.691V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.523 112.752H665.849V110.427H663.523V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.357 112.752H721.683V110.427H719.357V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.19 112.752H777.516V110.427H775.19V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.02 112.752H833.346V110.427H831.02V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.854 112.752H889.181V110.427H886.854V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.687 112.752H945.013V110.427H942.687V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.518 112.752H1000.84V110.427H998.518V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.35 112.752H1056.68V110.427H1054.35V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.19 112.752H1112.51V110.427H1110.19V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.02 112.752H1168.34V110.427H1166.02V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.85 112.752H1224.18V110.427H1221.85V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.68 112.752H1280.01V110.427H1277.68V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.52 112.752H1335.84V110.427H1333.52V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.35 112.752H1391.67V110.427H1389.35V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4468 56.9573H23.7732V54.6325H21.4468V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2813 56.9573H79.6077V54.6325H77.2813V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.113 56.9573H135.439V54.6325H133.113V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.944 56.9573H191.27V54.6325H188.944V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.782 56.9573H247.108V54.6325H244.782V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.609 56.9573H302.936V54.6325H300.609V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.441 56.9573H358.767V54.6325H356.441V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.278 56.9573H414.605V54.6325H412.278V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.11 56.9573H470.436V54.6325H468.11V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.938 56.9573H526.264V54.6325H523.938V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.775 56.9573H582.102V54.6325H579.775V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.607 56.9573H637.933V54.6325H635.607V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.441 56.9573H693.767V54.6325H691.441V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.274 56.9573H749.6V54.6325H747.274V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.104 56.9573H805.43V54.6325H803.104V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.938 56.9573H861.265V54.6325H858.938V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.771 56.9573H917.097V54.6325H914.771V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.602 56.9573H972.929V54.6325H970.602V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.44 56.957H1028.76V54.6322H1026.44V56.957Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.27 56.9573H1084.6V54.6325H1082.27V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.1 56.9573H1140.43V54.6325H1138.1V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.93 56.9573H1196.26V54.6325H1193.93V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.77 56.9573H1252.09V54.6325H1249.77V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.6 56.9573H1307.93V54.6325H1305.6V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.43 56.9573H1363.76V54.6325H1361.43V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1417.26 56.9573H1419.59V54.6325H1417.26V56.9573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4468 112.752H23.7732V110.427H21.4468V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2813 112.752H79.6077V110.427H77.2813V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.113 112.752H135.439V110.427H133.113V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.944 112.752H191.27V110.427H188.944V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.782 112.752H247.108V110.427H244.782V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.609 112.752H302.936V110.427H300.609V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.441 112.752H358.767V110.427H356.441V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.278 112.752H414.605V110.427H412.278V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.11 112.752H470.436V110.427H468.11V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.938 112.752H526.264V110.427H523.938V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.775 112.752H582.102V110.427H579.775V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.607 112.752H637.933V110.427H635.607V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.441 112.752H693.767V110.427H691.441V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.274 112.752H749.6V110.427H747.274V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.104 112.752H805.43V110.427H803.104V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.938 112.752H861.265V110.427H858.938V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.771 112.752H917.097V110.427H914.771V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.602 112.752H972.929V110.427H970.602V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.44 112.752H1028.76V110.427H1026.44V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.27 112.752H1084.6V110.427H1082.27V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.1 112.752H1140.43V110.427H1138.1V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.93 112.752H1196.26V110.427H1193.93V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.77 112.752H1252.09V110.427H1249.77V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.6 112.752H1307.93V110.427H1305.6V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.43 112.752H1363.76V110.427H1361.43V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1417.26 112.752H1419.59V110.427H1417.26V112.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3629 84.8535H51.6892V82.5287H49.3629V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.197 84.8535H107.524V82.5287H105.197V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.029 84.8535H163.355V82.5287H161.029V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.86 84.8535H219.186V82.5287H216.86V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.698 84.8535H275.024V82.5287H272.698V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.525 84.8535H330.852V82.5287H328.525V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.357 84.8535H386.683V82.5287H384.357V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.194 84.8535H442.521V82.5287H440.194V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.026 84.8535H498.352V82.5287H496.026V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.854 84.8535H554.18V82.5287H551.854V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.691 84.8535H610.018V82.5287H607.691V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.523 84.8535H665.849V82.5287H663.523V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.357 84.8535H721.683V82.5287H719.357V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.19 84.8535H777.516V82.5287H775.19V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.02 84.8535H833.346V82.5287H831.02V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.854 84.8535H889.181V82.5287H886.854V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.687 84.8535H945.013V82.5287H942.687V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.518 84.8535H1000.84V82.5287H998.518V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.35 84.8535H1056.68V82.5287H1054.35V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.19 84.8535H1112.51V82.5287H1110.19V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.02 84.8535H1168.34V82.5287H1166.02V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.85 84.8535H1224.18V82.5287H1221.85V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.68 84.8535H1280.01V82.5287H1277.68V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.52 84.8535H1335.84V82.5287H1333.52V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.35 84.8535H1391.67V82.5287H1389.35V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3629 140.648H51.6892V138.324H49.3629V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.197 140.648H107.524V138.324H105.197V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.029 140.648H163.355V138.324H161.029V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.86 140.648H219.187V138.324H216.86V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.698 140.648H275.024V138.324H272.698V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.525 140.648H330.852V138.324H328.525V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.357 140.648H386.683V138.324H384.357V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.194 140.648H442.521V138.324H440.194V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.026 140.648H498.353V138.324H496.026V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.854 140.648H554.18V138.324H551.854V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.691 140.648H610.018V138.324H607.691V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.523 140.648H665.849V138.324H663.523V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.357 140.648H721.683V138.324H719.357V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.19 140.648H777.516V138.324H775.19V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.019 140.648H833.346V138.324H831.019V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.854 140.648H889.181V138.324H886.854V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.687 140.648H945.013V138.324H942.687V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.518 140.648H1000.84V138.324H998.518V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.35 140.648H1056.68V138.324H1054.35V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.19 140.648H1112.51V138.324H1110.19V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.01 140.648H1168.34V138.324H1166.01V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.85 140.648H1224.18V138.324H1221.85V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.68 140.648H1280.01V138.324H1277.68V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.51 140.648H1335.84V138.324H1333.51V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.35 140.648H1391.67V138.324H1389.35V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4468 84.8535H23.7732V82.5287H21.4468V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2813 84.8535H79.6077V82.5287H77.2813V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.113 84.8535H135.439V82.5287H133.113V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.944 84.8535H191.27V82.5287H188.944V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.782 84.8535H247.108V82.5287H244.782V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.609 84.8535H302.936V82.5287H300.609V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.441 84.8535H358.767V82.5287H356.441V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.278 84.8535H414.605V82.5287H412.278V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.11 84.8535H470.436V82.5287H468.11V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.938 84.8535H526.264V82.5287H523.938V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.775 84.8535H582.102V82.5287H579.775V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.607 84.8535H637.933V82.5287H635.607V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.441 84.8535H693.767V82.5287H691.441V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.274 84.8535H749.6V82.5287H747.274V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.104 84.8535H805.43V82.5287H803.104V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.938 84.8535H861.265V82.5287H858.938V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.771 84.8535H917.097V82.5287H914.771V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.602 84.8535H972.929V82.5287H970.602V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.44 84.8535H1028.76V82.5287H1026.44V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.27 84.8535H1084.6V82.5287H1082.27V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.1 84.8535H1140.43V82.5287H1138.1V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.93 84.8535H1196.26V82.5287H1193.93V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.77 84.8535H1252.09V82.5287H1249.77V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.6 84.8535H1307.93V82.5287H1305.6V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.43 84.8535H1363.76V82.5287H1361.43V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1417.26 84.8535H1419.59V82.5287H1417.26V84.8535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4468 140.648H23.7732V138.324H21.4468V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2813 140.648H79.6077V138.324H77.2813V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.113 140.648H135.439V138.324H133.113V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.944 140.648H191.27V138.324H188.944V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.782 140.648H247.108V138.324H244.782V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.609 140.648H302.936V138.324H300.609V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.441 140.648H358.767V138.324H356.441V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.278 140.648H414.604V138.324H412.278V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.11 140.648H470.437V138.324H468.11V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.938 140.648H526.264V138.324H523.938V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.775 140.648H582.102V138.324H579.775V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.607 140.648H637.933V138.324H635.607V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.441 140.648H693.767V138.324H691.441V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.274 140.648H749.6V138.324H747.274V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.103 140.648H805.43V138.324H803.103V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.938 140.648H861.265V138.324H858.938V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.771 140.648H917.097V138.324H914.771V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.602 140.648H972.929V138.324H970.602V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.44 140.648H1028.76V138.324H1026.44V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.27 140.648H1084.6V138.324H1082.27V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.1 140.648H1140.43V138.324H1138.1V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.93 140.648H1196.26V138.324H1193.93V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.77 140.648H1252.09V138.324H1249.77V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.6 140.648H1307.93V138.324H1305.6V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.43 140.648H1363.76V138.324H1361.43V140.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1417.26 140.648H1419.59V138.324H1417.26V140.648Z",
    fill: "black"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-34.386 55.7927C-3.55028 55.7927 21.4467 80.7728 21.4467 111.588H77.2794C77.2794 49.958 27.2854 -0.00213623 -34.386 -0.00213623C-96.0573 -0.00213623 -146.051 49.958 -146.051 111.588H-90.2186C-90.2186 80.7728 -65.2216 55.7927 -34.386 55.7927Z",
    fill: "#F4F4F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M525.104 139.486C525.104 154.894 512.606 167.383 497.188 167.383C481.77 167.383 469.271 154.894 469.271 139.486C469.271 124.077 481.77 111.588 497.188 111.588C512.606 111.588 525.104 124.077 525.104 139.486Z",
    fill: "#F4F4F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.108 83.691C190.108 99.0987 177.61 111.588 162.192 111.588C146.774 111.588 134.276 99.0987 134.276 83.691C134.276 68.2822 146.774 55.793 162.192 55.793C177.61 55.793 190.108 68.2822 190.108 83.691Z",
    fill: "#F4F4F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.773 167.383C301.773 136.568 326.77 111.588 357.605 111.588V55.7932C295.934 55.7932 245.94 105.753 245.94 167.383C245.94 229.013 295.934 278.973 357.605 278.973V223.178C326.77 223.178 301.773 198.198 301.773 167.383Z",
    fill: "#F4F4F5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_52722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 160,
    fill: "white",
    transform: "translate(1440 160) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageHeroSubHeader);
export default __webpack_public_path__ + "static/media/Homepage-Hero-SubHeader.632dfd519c7e9424384913fc4794f311.svg";
export { ForwardRef as ReactComponent };